/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect, useState } from 'preact/hooks';

const MainInput = ({ query, pluginNamespace, layoutClass }) => {
  const [searchQuery, setSearchQuery] = useState(query);
  const searchInputEl = useRef(null);

  useEffect(() => setSearchQuery(query), [query]);

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setSearchQuery(value);
    }
  }

  return (
    <div className={`searchbar ${layoutClass}`}>
      <label htmlFor="searchbar-input" className="sr-only">
        {labels.search.mainInputLabel}
      </label>
      <input
        id="searchbar-input"
        className="input"
        data-main-input
        name={`${pluginNamespace}[q]`}
        value={searchQuery}
        ref={searchInputEl}
        onChange={handleInputChange}
        autocomplete="off"
        placeholder={labels.search.mainInputPlaceholder || ''}
        type="text"
      />
      {searchQuery ? (
        <button
          className="searchbar__button"
          type="button"
          onClick={() => setSearchQuery('')}
        >
          <span className="sr-only">{labels.search.resetSearchTerm || ''}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-close"
            viewBox="0 0 22.02 22.02"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="m12.71 11.01 8.96-8.96a1.201 1.201 0 1 0-1.7-1.7l-8.96 8.96L2.05.35a1.201 1.201 0 1 0-1.7 1.7l8.96 8.96-8.96 8.96a1.201 1.201 0 1 0 1.7 1.7l8.96-8.96 8.96 8.96a1.204 1.204 0 0 0 1.7 0c.47-.47.47-1.23 0-1.7l-8.96-8.96Z"
            />
          </svg>
        </button>
      ) : (
        ''
      )}
      <button className="searchbar__button" type="submit" value="Search">
        <span className="sr-only">{labels.search.submit || ''}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-search"
          viewBox="0 0 24.03 24.08"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="m21.72 23.59-7.82-7.8c-.65.53-1.4.95-2.28 1.25-.87.3-1.81.45-2.81.45-2.46 0-4.54-.85-6.25-2.56S0 11.16 0 8.75s.85-4.48 2.56-6.19S6.34 0 8.76 0s4.48.85 6.18 2.56c1.7 1.71 2.55 3.77 2.55 6.19 0 .97-.14 1.88-.43 2.74-.29.86-.72 1.67-1.3 2.42l7.89 7.82c.26.26.39.57.39.92s-.14.67-.42.94c-.27.27-.59.41-.96.41s-.69-.14-.94-.41ZM8.78 14.88c1.7 0 3.15-.6 4.33-1.8 1.18-1.2 1.77-2.64 1.77-4.34s-.59-3.14-1.77-4.34c-1.18-1.2-2.62-1.8-4.32-1.8s-3.18.6-4.38 1.8c-1.2 1.2-1.8 2.64-1.8 4.34s.6 3.14 1.8 4.34c1.2 1.2 2.66 1.8 4.38 1.8Z"
          />
        </svg>
      </button>
    </div>
  );
};

export default MainInput;
